<template lang="pug">
  .pay-checkboxGroup-container(:class="{'flex': displayColumn === 'h'}")
    label.mr-16.h-21.block.mb-8(v-if="label")
      span {{label}}
      span.text-red-200.mr-1(v-if="required") *
    .checkboxGroup.justify-start(:class="{'flex': displayColumn != 'h'}")
      label.select-none.checkbox.relative.cursor-pointer.pl-20.mr-16.mb-12(v-for="(item,index) in options" :key="item.val" 
      :class="{'flex': displayColumn === 'h', 'block': optionDisplayColumn ,'inline-block' : !optionDisplayColumn}"
      )
        input.absolute.opacity-0.left-0.cursor-pointer(:value="item.val"  type="checkbox" v-model="checkedValue" :disabled="item.disabled" )
        span.ml-8.pt-2.block {{item.name}} 
        //- span.h-18.w-18.checkmark.absolute.top-0.left-0.border.border-grey-99.transform.rounded-50(class="top-1/2 -translate-y-1/2" :class="{'border-error': error && !item.disabled}")
        span.h-20.w-20.checkmark.absolute.top-0.left-0.border.border-black.rounded-4.transform(class="top-1/2 -translate-y-1/2" :class="{'border-error': error && !item.disabled}")
    .error.h-21.flex.items-center(v-show="error")
      small.text-red-200 {{error}}
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    error: String,
    displayColumn: String,
    optionDisplayColumn: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    value: {
      type: Array,
      required: true
    },
    required: Boolean
  },
  data() {
    return {
      // checkedValue: this.value,
    };
  },
  computed: {
    checkedValue: {
      get() {
        //這裡的this.value會是一個陣列，根據勾選的checkbox而定
        return this.value;
      },
      set(val) {
        this.$emit("changeValue", val);
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
//打勾後
.checkbox input {
  &:checked ~ .checkmark {
    // @apply bg-main-0;
  }
  &:disabled ~ .checkmark {
    opacity: 0.6;
    @apply border-black;
  }
  &:disabled ~ span {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:checked {
    &:disabled ~ .checkmark {
      // opacity: 0.6;
    }
  }
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

//打勾後物件狀態
.checkbox input:checked ~ .checkmark:after {
  display: inline-block;
}

.checkbox input:checked ~ .checkmark:before {
  display: none;
}

//勾勾

.checkbox .checkmark:after {
  //超出框框的版本
  // left: 7px;
  // top: -3px;
  // width: 7px;
  // height: 14px;
  // 圓的的版本
  left: 6px;
  top: 1px;
  width: 6px;
  height: 12px;
  @apply border-main-deep;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

//hover

.checkbox:hover {
  input:not([disabled]) {
    & ~ .checkmark {
      //沒打勾的邊邊變色
      @apply border-main-deep;
    }
    &:checked ~ .checkmark {
      //有打勾的背景變色
      @apply bg-white;
    }
    &:checked ~ .checkmark:after {
      //有打勾的勾勾變色
      @apply border-main-0;
    }
  }
}

//active

.checkbox:active {
  input:not([disabled]) {
    & ~ .checkmark {
      @apply border-main-deep;
    }
    &:checked ~ .checkmark {
      //有打勾的背景變色
      @apply border-main-0;
    }
    &:checked ~ .checkmark:after {
      @apply border-white;
    }
  }
}

// .checkbox input:disabled ~ .checkmark {
//   @apply bg-grey-E6;
// }

// //打勾後
// .checkbox input{
//   &:checked ~ .checkmark {
//     @apply bg-main-sub5;
//   }
//   &:disabled ~ .checkmark {
//     opacity: 0.6;
//     @apply border-black ;
//     &:before {
//       display: none;
//     }
//   }
//   &:disabled ~ span {
//     opacity: 0.6;
//     cursor: not-allowed;
//   }
//   &:checked{
//     &:disabled ~ .checkmark {
//       // opacity: 0.6;
//     }
//   }
// }

// .checkmark:after {
//   content: "";
//   position: absolute;
//   display: none;
// }

// //new
// .checkmark:before {
//   content: "";
//   position: absolute;
//   width: 10px;
//   height: 10px;
//   border-radius: 2px;
//   background-color: #1247b2;
//   margin: 4px;
//   transition: 0.02s ease-in-out ;
// }

// //打勾後物件狀態
// .checkbox input:checked ~ .checkmark:after {
//   display: inline-block;
// }

// .checkbox input:checked ~ .checkmark:before {
//   display: none;
// }

// //勾勾

// .checkbox .checkmark:after {
//   //超出框框的版本
//   // left: 7px;
//   // top: -3px;
//   // width: 7px;
//   // height: 14px;
//   // 圓的的版本
//   left: 6px;
//   top: 1px;
//   width: 6px;
//   height: 12px;
//   border: solid white;
//   border-width: 0 2px 2px 0;
//   transform: rotate(45deg);
// }

// //hover

// .checkbox:hover{
//   input:not([disabled]) {
//     & ~ .checkmark{ //沒打勾的邊邊變色
//       // background-color: #00c9c9 !important;
//       @apply border-main-sub5;
//     }
//     &:checked ~ .checkmark { //有打勾的背景變色
//       @apply bg-white;
//     }
//     &:checked ~ .checkmark:after{ //有打勾的勾勾變色
//       @apply border-main-sub5;

//     }
//     & ~ .checkmark:before {
//       content: " ";
//       position: absolute;
//       opacity: 0;
//       width: 0px;
//       height: 0px;
//     }
//   }
// }

// //active

// .checkbox:active{
//   input:not([disabled]) {
//     & ~ .checkmark{
//       background-color: #1247b2 !important;
//       @apply border-main-sub5 ;
//     }
//     &:checked ~ .checkmark { //有打勾的背景變色
//     background-color: white !important;
//     @apply border-black ;
//     }
//     &:checked ~ .checkmark:after{
//       @apply border-white;
//     }
//   }

// }
</style>
